function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import { createElement } from 'react';
import PropTypes from 'prop-types';
import Fieldset from './Fieldset';

var Form = function (_Fieldset) {
  _inherits(Form, _Fieldset);

  function Form() {
    var _this2 = this;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, _Fieldset.call.apply(_Fieldset, [this].concat(args)));

    _this.onSubmit = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evn) {
        var _this$props, onSubmit, onError, validate, value, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evn.preventDefault();

                if (!_this.working) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this.working = true;
                _this.notifyChildren();

                _this$props = _this.props, onSubmit = _this$props.onSubmit, onError = _this$props.onError, validate = _this$props.validate;
                value = _this.getValue();

                if (!validate) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return validate(value);

              case 10:
                _context.t0 = _context.sent;
                _context.next = 14;
                break;

              case 13:
                _context.t0 = [];

              case 14:
                _this.errors = _context.t0;
                errors = _this.errors;

                if (!(!errors.length && onSubmit)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 19;
                return onSubmit(value);

              case 19:
                _context.next = 24;
                break;

              case 21:
                if (!(errors && errors.length && onError)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 24;
                return onError(errors, value);

              case 24:

                _this.working = false;
                _this.notifyChildren();

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.defaultValue = _this.props.defaultValue;
    return _this;
  }

  Form.prototype.getCurrentValue = function getCurrentValue(props) {
    var defaultValue = this.defaultValue;
    var value = props.value;


    return defaultValue !== undefined ? defaultValue : value;
  };

  Form.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    // reinit default value
    var enableReinitialize = props.enableReinitialize,
        defaultValue = props.defaultValue;

    if (enableReinitialize && defaultValue !== this.props.defaultValue) {
      this.defaultValue = defaultValue;
    }

    var value = this.getCurrentValue(props);
    this.setValue(value, this, true);
  };

  Form.prototype.getPath = function getPath() {
    return undefined;
  };

  Form.prototype.getOriginalValue = function getOriginalValue() {
    return this.getCurrentValue(this.props);
  };

  Form.prototype.getParent = function getParent() {
    var ignoreParent = this.props.ignoreParent;

    if (ignoreParent) {
      return undefined;
    }

    return _Fieldset.prototype.getParent.call(this);
  };

  Form.prototype.getForm = function getForm() {
    var ignoreParent = this.props.ignoreParent;

    if (ignoreParent) {
      return this;
    }

    var parent = this.getParent();
    return parent ? parent.getForm() : this;
  };

  Form.prototype.getErrors = function getErrors(path, exactMatch) {
    var errors = this.errors || [];
    if (!path) {
      return errors;
    }

    var parentPath = path + '.';

    return errors.filter(function (error) {
      if (!error.path) {
        return false;
      }

      if (error.path === path) {
        return true;
      }

      if (!exactMatch && error.path.indexOf(parentPath) === 0) {
        return true;
      }

      return false;
    });
  };

  Form.prototype.hasErrors = function hasErrors(path, exact) {
    return !!this.getErrors(path, exact).length;
  };

  Form.prototype.isValid = function isValid(path, exact) {
    return !this.hasErrors(path, exact);
  };

  Form.prototype.isWorking = function isWorking() {
    return !!this.working;
  };

  Form.prototype.setValue = function setValue(value, component, notifyChildren) {
    this.clearErrors();

    _Fieldset.prototype.setValue.call(this, value, component, notifyChildren);
  };

  Form.prototype.clearErrors = function clearErrors() {
    this.errors = [];
  };

  Form.prototype.getClassName = function getClassName() {
    var _props = this.props,
        className = _props.className,
        tagName = _props.tagName;

    return className || tagName;
  };

  Form.prototype.render = function render() {
    var _props2 = this.props,
        autoComplete = _props2.autoComplete,
        tagName = _props2.tagName,
        children = _props2.children,
        method = _props2.method,
        action = _props2.action;


    var props = tagName === 'form' ? {
      autoComplete: autoComplete,
      method: method,
      action: action,
      className: this.getClassName(),
      onSubmit: this.onSubmit
    } : {
      className: this.getClassName()
    };

    return createElement(tagName, props, this.processChildren(children));
  };

  return Form;
}(Fieldset);

Form.propTypes = {
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  skipReplace: PropTypes.bool,
  value: PropTypes.any, // eslint-disable-line
  method: PropTypes.string,
  action: PropTypes.string,
  autoComplete: PropTypes.string,
  children: PropTypes.node,
  tagName: PropTypes.string.isRequired,
  debounce: PropTypes.number,
  validate: PropTypes.func,
  sameChildren: PropTypes.bool,
  defaultValue: PropTypes.any, // eslint-disable-line
  enableReinitialize: PropTypes.bool,
  ignoreParent: PropTypes.bool
};
Form.defaultProps = {
  autoComplete: 'off',
  tagName: 'form',
  debounce: 250,
  enableReinitialize: false,
  ignoreParent: false
};
Form.childContextTypes = {
  fieldset: PropTypes.object.isRequired
};
Form.contextTypes = {
  fieldset: PropTypes.object
};
export default Form;
//# sourceMappingURL=Form.js.map